/**
 * Page is only accessible if user is a guest.
 */

export default function({ to, from, store }) {
    // Store referral.
    if (to.query.ref && to.query.ref.trim() !== '') {
        store.commit('setRef', to.query.ref);
    }
    if (store.getters.apiKey) {
        if (to.query.redirect) {
            return { path: to.query.redirect };
        } else if (to.name === 'ltd') {
            return { name: 'account.ltd' };
        } else {
            return { name: 'dashboard' };
        }
    }
}
